import { useEffect, useState } from "react";
import Cropper from "react-easy-crop";
import { cropImage } from "./cropImage.js";
import "./ImageCropper.css";

const CROP_CONFIGS = {
  avatar: {
    cropShape: "round",
    aspect: 1,
    targetWidth: 200,
    targetHeight: 200,
    title: "Cortar imagem do profissional",
    showGrid: false,
  },
  salon: {
    cropShape: "rect",
    aspect: 4 / 3,
    targetWidth: 1000,
    targetHeight: 750,
    title: "Cortar imagem do salão",
    showGrid: true,
  },
};

export default function ImageCropper({ file, cropType = "avatar", onComplete, onCancel }) {
  const config = CROP_CONFIGS[cropType] || CROP_CONFIGS.avatar;
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);

  useEffect(() => {
    if (!file) return;
    const url = URL.createObjectURL(file);
    setImageUrl(url);
    setCrop({ x: 0, y: 0 });
    setZoom(1);
    setCroppedAreaPixels(null);
    setError(null);

    return () => URL.revokeObjectURL(url);
  }, [file]);

  const handleCropComplete = (_area, areaPixels) => {
    setCroppedAreaPixels(areaPixels);
  };

  const handleConfirm = async () => {
    if (!file || !croppedAreaPixels || processing) return;
    setProcessing(true);
    setError(null);
    try {
      const croppedFile = await cropImage({
        file,
        crop: croppedAreaPixels,
        targetWidth: config.targetWidth,
        targetHeight: config.targetHeight,
      });
      onComplete(croppedFile);
    } catch (err) {
      setError(err.message || "Erro ao cortar imagem");
      setProcessing(false);
    }
  };

  if (!file || !imageUrl) return null;

  return (
    <div className="image-cropper-overlay" role="dialog" aria-modal="true" aria-label="Cortar imagem">
      <div className="image-cropper-modal">
        <div className="image-cropper-header">
          <h3>{config.title}</h3>
          <p>Arraste a imagem e ajuste o zoom para escolher o enquadramento.</p>
        </div>
        <div className="image-cropper-body">
          <Cropper
            image={imageUrl}
            crop={crop}
            zoom={zoom}
            aspect={config.aspect}
            cropShape={config.cropShape}
            showGrid={config.showGrid}
            minZoom={1}
            maxZoom={3}
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={handleCropComplete}
          />
        </div>
        <div className="image-cropper-controls">
          <label className="image-cropper-zoom">
            Zoom
            <input
              type="range"
              min="1"
              max="3"
              step="0.01"
              value={zoom}
              onChange={(e) => setZoom(Number(e.target.value))}
            />
          </label>
          <div className="image-cropper-actions">
            <button className="btn-sm" type="button" onClick={onCancel} disabled={processing}>
              Cancelar
            </button>
            <button
              className="submit-btn"
              type="button"
              onClick={handleConfirm}
              disabled={processing || !croppedAreaPixels}
            >
              {processing ? "A cortar…" : "Confirmar"}
            </button>
          </div>
        </div>
        {error && <div className="image-cropper-error">{error}</div>}
      </div>
    </div>
  );
}
